/**
 * Arayüz anahtarları (Faz 0)
 *  - Yeni kabuk: herkese açık. app_config.crm_ui_v2 = 'false' → acil fren,
 *    herkes eski kabuğa döner. Anahtar yoksa AÇIK kabul edilir.
 *  - Labs: yalnız geliştirici. crm_staff.labs_enabled (hesaba bağlı) ya da
 *    tarayıcıda ?labs=1 / ?labs=0 ile.
 */
import { useEffect, useSyncExternalStore } from "react";
import { supabaseClient } from "../providers/supabase-client";
import { useStaff } from "./staff";

const UI_KEY = "edel_ui_v2";
const LABS_KEY = "edel_labs";

const read = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};
const write = (key: string, value: string) => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* gizli sekme vb. — sessizce yoksay */
  }
};

// Küçük abonelik deposu: anahtar değişince tüm kullanıcılar yeniden çizilir.
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

let remoteChecked = false;

/** Yeni kabuk açık mı? İlk çizimde son bilinen değer, sonra app_config. */
export function useShellV2(): boolean {
  const cached = useSyncExternalStore(subscribe, () => read(UI_KEY));
  useEffect(() => {
    if (remoteChecked) return;
    let alive = true;
    // app_config yalnız oturum açmış kullanıcıya okunur (RLS). Oturum yokken
    // (giriş ekranı) sorgulama yapılmaz; aksi halde boş sonuç "açık" sanılır.
    supabaseClient.auth.getSession().then(({ data: s }) => {
      if (!alive || !s.session || remoteChecked) return;
      remoteChecked = true;
      supabaseClient
        .from("app_config")
        .select("value")
        .eq("key", "crm_ui_v2")
        .maybeSingle()
        .then(({ data, error }) => {
          if (error) return; // okunamazsa son bilinen değerle devam
          const next = data?.value?.trim().toLowerCase() === "false" ? "0" : "1";
          if (next !== read(UI_KEY)) {
            write(UI_KEY, next);
            emit();
          }
        });
    });
    return () => {
      alive = false;
    };
  }, []);
  return cached !== "0";
}

/**
 * Labs açık mı? Kalıcı kaynak crm_staff.labs_enabled (hesaba bağlı);
 * tarayıcıdaki ?labs=1 ayarı geliştirme kolaylığı olarak ek açma yoludur.
 */
export function useLabs(): [boolean, (on: boolean) => void] {
  const value = useSyncExternalStore(subscribe, () => read(LABS_KEY));
  const staff = useStaff();
  const set = (on: boolean) => {
    write(LABS_KEY, on ? "1" : "0");
    emit();
  };
  return [value === "1" || !!staff?.labs_enabled, set];
}

/** ?labs=1 / ?labs=0 adres parametresini okuyup Labs'ı açar/kapatır. */
export function applyLabsParam(search: string): boolean | null {
  const v = new URLSearchParams(search).get("labs");
  if (v === "1" || v === "0") {
    write(LABS_KEY, v);
    emit();
    return v === "1";
  }
  return null;
}
